export default "__VITE_ASSET__IRrjkgJY__"